"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SelectOption = void 0;
var _react = _interopRequireWildcard(require("react"));
require("./Select.scss");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Icon = _interopRequireDefault(require("../../components/Icon/Icon"));
var _useMouse = _interopRequireDefault(require("../../utils/hooks/useMouse"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const Select = _ref => {
  let {
    handleSelection,
    options = [],
    selection,
    defaultText,
    name = "select",
    warning,
    color
  } = _ref;
  const {
    mouse
  } = (0, _useMouse.default)();
  const [isWindows, setIsWindows] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    // TODO: update/test hook to "navigator && setIsWindows(navigator.userAgent.includes("Win"))"
    if (navigator !== undefined) {
      if (navigator.userAgent.indexOf("Win") != -1) {
        setIsWindows(true);
      } else {
        setIsWindows(false);
      }
    }
  }, [isWindows]);
  const generateOptions = () => {
    let generatedOptions = [];
    generatedOptions.push( /*#__PURE__*/_react.default.createElement(SelectOption, {
      hide: true,
      key: "placeholder-text",
      option: defaultText,
      isWindows: isWindows
    }));
    options.forEach((option, index) => {
      generatedOptions.push( /*#__PURE__*/_react.default.createElement(SelectOption, {
        key: `${option}-${index}`,
        option: option,
        isWindows: isWindows
      }));
    });
    return generatedOptions;
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: `ter-select__wrapper ${warning ? "ter-select__wrapper--warning" : ""}`
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    type: "open-caret-down-dark-16px",
    size: "16px",
    color: color ? color : "#242D2F"
  }), /*#__PURE__*/_react.default.createElement("select", {
    onChange: e => handleSelection(e.target.value, name),
    className: `${mouse ? "ter-select" : "ter-select tabFocus"} ${warning ? "ter-select--warning" : ""} `,
    value: selection || ""
  }, generateOptions()));
};
const SelectOption = _ref2 => {
  let {
    option,
    hide,
    isWindows
  } = _ref2;
  return /*#__PURE__*/_react.default.createElement("option", {
    value: hide ? "hide" : option,
    className: `ter-select__options-list-item ter-select-options ${isWindows ? "ter-select-options--windows" : "ter-select-options--not-windows"}`
  }, option);
};
exports.SelectOption = SelectOption;
var _default = Select;
exports.default = _default;
Select.propTypes = {
  options: _propTypes.default.arrayOf(_propTypes.default.string).isRequired,
  handleSelection: _propTypes.default.func.isRequired,
  selection: _propTypes.default.string,
  defaultText: _propTypes.default.string.isRequired,
  name: _propTypes.default.string.isRequired
};